module.exports = __webpack_public_path__ + "static/img/6.ccfd728a.png";